module.exports = __webpack_public_path__ + "static/home-office-c416903f92c7999dd9328f36653833d4.jpg";